export default __webpack_public_path__ + "static/media/gallery-wip-emitter-shroud_03.9aec8bac.jpg";